import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from '@fluentui/react/lib/Button';

let styles = require('./SidePane.scss');
let classNames = require('classnames/bind').bind(styles);

export interface SidePaneProps {
    isOpened: boolean;
    title?: string;
    onClose?: () => void;
    showHeader?: boolean;
    children?: React.ReactNode;
}

export default function SidePane(props: SidePaneProps) {
    const renderHeader = () => {
        let { title, onClose } = props;
        return (
            <div className={styles.sidePaneHeader}>
                <span>{title}</span>
                <IconButton iconProps={{ iconName: ControlIcons.Cancel }} onClick={onClose} />
            </div>
        );
    };
    let { isOpened, children } = props;
    let showHeader = props.showHeader === undefined ? true : props.showHeader;
    return (
        <div
            className={classNames(styles.sidePane, {
                flyIn: isOpened,
                flyOut: !isOpened,
            })}>
            {showHeader && renderHeader()}
            <div className={showHeader ? styles.sidePaneBody : styles.sidePaneBodyNoHeader}>
                {isOpened && children}
            </div>
        </div>
    );
}
